'use client'

import UserNavbar from '@/(front-desk)/components/UserNavbar'
import { loginPages } from '@/(front-desk)/layout'
import { handleGlobal } from '@/(front-desk)/store'
import { getAccountInfo, getRegistries, getSchoolList } from '@/(front-desk)/utils/dataFetch'
import { usePathname, useRouter } from 'next/navigation'
import { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Footer from '@/(front-desk)/components/Footer'
import Error from '@/error'
import lscache from 'lscache'


export default function FrontPageLayout({ children }) {

    const dispatch = useDispatch()
    const router = useRouter()
    const pathname = usePathname()
    const account = useSelector((state) => state.account)
    const global = useSelector((state) => state.global)
    const sentryErrorEventId = global.sentryErrorEventId

    useEffect(() => {
        handleYearList()
        getRegistries(dispatch)
    }, [])

    useEffect(() => {
        if (!account.data && lscache.get('access')) {
            getAccountInfo(dispatch)
        }
    }, [account.data])

    useEffect(() => {
        if (global.schoolList === null && global.currentExhibitYear) {
            getSchoolList(global.currentExhibitYear)
        }
    }, [global.currentExhibitYear])

    useEffect(() => {
        if (lscache.get('access')) {
            if (pathname === '/user/login') {
                router.push(global.userDefaultUrl)
            }
        }
        else {
            if (loginPages.indexOf(pathname) === -1) {
                router.push('/user/login')
            }
        }
    }, [pathname])

    function handleYearList() {
        const startYear = new Date().getFullYear() + 5
        let list = []
        for (let i = 0; i < 100; i++) {
            list.push(startYear - i)
        }
        dispatch(handleGlobal.actions.setYearList(list))
    }


    return (
        <>
            {(loginPages.indexOf(pathname) !== -1 || account.data) &&
                <Fragment>
                    <UserNavbar />
                    {children}
                    {(!loginPages.includes(pathname) && !pathname.startsWith("/user/judge")) &&
                        <Footer />
                    }
                </Fragment>
            }
            { sentryErrorEventId && <Error id={sentryErrorEventId} /> }
        </>
    )
}
